export const INVITE_FLOW_FLAG_KEY = 'inviteFlow';

export const setInviteFlowFlag = (isInviteFlow: boolean) => {
  if (isInviteFlow) {
    sessionStorage.setItem(INVITE_FLOW_FLAG_KEY, 'true');
    return;
  }

  sessionStorage.removeItem(INVITE_FLOW_FLAG_KEY);
};

export const isInviteFlowEnabled = (): boolean => sessionStorage.getItem(INVITE_FLOW_FLAG_KEY) === 'true';

export const clearInviteFlowFlag = () => {
  sessionStorage.removeItem(INVITE_FLOW_FLAG_KEY);
};
